import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { arrayMove } from 'react-sortable-hoc';

// Components
import SortableList from './SortableList';
import Loader from '../../utils/Loader';

// State
import { userTokenUpdate, userLogout } from '../../../store/actions/user';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars';

class AdminCategorySortList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permalink: !!props.match.params.permalink ? props.match.params.permalink : '',
            categories: [],
            isLoading: false,
            updateLoading: false,
            updateErrors: {},
            updateSuccess: '',
        };
    }

    componentDidMount() {
        this.loadData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.permalink !== this.props.match.params.permalink) {
            this.setState(
                {
                    permalink: nextProps.match.params.permalink,
                },
                () => {
                    this.loadData();
                }
            );
        }
    }

    loadData() {
        this.setState(
            {
                isLoading: true,
            },
            () => {
                const { permalink } = this.state;

                const apiEndpoint = permalink === '' ? 'categories/' : 'category/';
                const params = permalink === '' ? { grouped: true } : {};

                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
                return axios
                    .get(REACT_APP_API_URL + apiEndpoint + permalink, {
                        params: params,
                        headers: AUTH_HEADER,
                    })
                    .then((response) => {
                        if (
                            response.status !== 200 ||
                            (response.data.status && response.data.status !== 200)
                        ) {
                            this.setState({
                                isLoading: false,
                                error: response.data.message,
                            });
                        } else {
                            // Convert obj to array
                            const cats = [];
                            Object.keys(response.data.categories).map((key) =>
                                cats.push(response.data.categories[key])
                            );

                            this.setState({
                                isLoading: false,
                                categories: cats,
                            });
                        }
                    })
                    .catch((err) => {
                        if (err.response) {
                            this.setState({
                                isLoading: false,
                                error: err.response.data.errors
                                    ? err.response.data.errors
                                    : err.response.data.message,
                            });
                        } else {
                            this.setState({ isLoading: false, error: err.message });
                        }
                    });
            }
        );
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            categories: arrayMove(this.state.categories, oldIndex, newIndex),
        });
    };

    // ===================================================================================
    //  SUBMIT
    // ===================================================================================
    handleSubmit() {
        const { user } = this.props;

        this.setState({
            updateErrors: {},
            updateLoading: true,
        });

        const data = {
            category: this.state.categories.map((cat) => {
                return cat.id;
            }),
        };

        const token = user.token;
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token };
        return axios
            .post(REACT_APP_API_URL + 'categories/order', data, { headers: AUTH_HEADER })
            .then((response) => {
                if (!!response.data.token) {
                    this.props.userTokenUpdate('admin', response.data.token);
                }

                if (response.data.status === 403) {
                    this.props.userLogout('admin');
                } else if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: !isEmpty(response.data.errors)
                            ? response.data.errors
                            : { general: response.data.message },
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateSuccess: response.data.message,
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: {
                            general: err.response.data.error
                                ? err.response.data.error
                                : err.response.data.message,
                        },
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateErrors: { general: err.message },
                    });
                }
            });
    }

    render() {
        const { isLoading, updateLoading, updateSuccess, updateErrors } = this.state;

        return (
            <div>
                {/* Loading */}
                {isLoading ? (
                    <div className="pt2 pb2">
                        <Loader />
                    </div>
                ) : (
                    // Show the form
                    <div>
                        <SortableList
                            items={this.state.categories}
                            onSortEnd={this.onSortEnd}
                            transitionDuration={200}
                            useDragHandle={true}
                            updateLoading={updateLoading}
                        />

                        <div className="btn_container">
                            {!!updateErrors.general && (
                                <div className="error msg_animate">
                                    {updateErrors.general}
                                </div>
                            )}

                            {updateSuccess && (
                                <div className="success msg_animate">{updateSuccess}</div>
                            )}
                            <button
                                className={
                                    'btn submit-btn' + (updateLoading ? ' loading' : '')
                                }
                                onClick={() => this.handleSubmit()}
                                disabled={updateLoading}
                            >
                                <span>Submit</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
    };
};

export default connect(
    mapStateToProps,
    { userTokenUpdate, userLogout }
)(AdminCategorySortList);



// WEBPACK FOOTER //
// ./src/components/admin/categories-sort/AdminCategorySortList.js